import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ListCardContentComponent } from './list-card-content/list-card-content.component';
import { RatingModule } from '../rating/rating.module';
import { TranslateModule } from '@ngx-translate/core';
import { AppPipesModule } from '../../pipes/app-pipes/app-pipes.module';

@NgModule({
  declarations: [ListCardContentComponent],
  imports: [CommonModule, RatingModule, TranslateModule, AppPipesModule],
  exports: [ListCardContentComponent]
})
export class ListCardContentModule {}
